import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'account.title',
    defaultMessage: 'My Account',
  },
  description: {
    id: 'account.description',
    defaultMessage:
      'Edit your account, check your orders, re-download products, find your serials, and more.',
  },
  accountSettings: {
    id: 'account.accountSettings',
    defaultMessage: 'Account Settings',
  },
  accountSettingsDescription: {
    id: 'account.accountSettings.description',
    defaultMessage:
      'Edit your account settings – name, email, password, address.',
  },
  orderHistory: {
    id: 'account.orderHistory',
    defaultMessage: 'Order History',
  },
  orderHistoryDescription: {
    id: 'account.orderHistory.description',
    defaultMessage:
      'View all your past orders and check the status of your open orders.',
  },
  productsSerialsAndDownloads: {
    id: 'account.productsSerialsAndDownloads',
    defaultMessage: 'Products, Serials & Downloads',
  },
  productsSerialsAndDownloadsDescription: {
    id: 'account.productsSerialsAndDownloads.description',
    defaultMessage:
      'See all of your products and serials, and re-download installers.',
  },
  coupons: {
    id: 'account.coupons',
    defaultMessage: 'Vouchers',
  },
  couponsDescription: {
    id: 'account.coupons.description',
    defaultMessage:
      'Find all your valid e-vouchers here. You can redeem them at the NI Online Shop.',
  },
  licenseTransfer: {
    id: 'account.licenseTransfer',
    defaultMessage: 'License transfer',
  },
  licenseTransferDescription: {
    id: 'account.licenseTransfer.description',
    defaultMessage:
      'Transfer a product license onto another user account, or import a license into your own account.',
  },
  updatesAndDrivers: {
    id: 'account.updatesAndDrivers',
    defaultMessage: 'Updates and Drivers',
  },
  updatesAndDriversDescription: {
    id: 'account.updatesAndDrivers.description',
    defaultMessage:
      'Check for the latest free software updates and drivers, or download the NI Service Center and other tools.',
  },
});
